<template>
<div class="chapter">
<div class="inner_page">
<p class="block_13" id="calibre_pb_3"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_12"> </p>
<p class="block_14"><span class="text_6">And how shall you rise beyond your days and</span></p>
<p class="block_14"><span class="text_6">nights unless you break the chains which you at the</span></p>
<p class="block_14"><span class="text_6">dawn of your understanding have fastened around</span></p>
<p class="block_14"><span class="text_6">your noon hour?</span></p>
<p class="block_15"> </p>
<p class="block_14"><span class="text_6">In truth that which you call freedom is the strongest</span></p>
<p class="block_14"><span class="text_6">of these chains, though its links glitter in the sun</span></p>
<p class="block_14"><span class="text_6">and dazzle your eyes.</span></p>
<p class="block_15"> </p>
<p class="block_16"><span class="text_7">from </span><span class="text_8">The Prophet</span><span class="text_7"> by Kahlil Gibran</span></p>
<p class="block_17"><span class="text_2"><br class="calibre1" id="calibre_pb_4"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?016e3493